module.exports = __webpack_public_path__ + "img/table.7742f61f.png";